// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-55c4130b] .jv-container .jv-code.open {\n  max-height: 700px !important;\n  overflow: auto;\n}\n[data-v-55c4130b] .cell_stayle {\n  vertical-align: top;\n}\n", ""]);
// Exports
module.exports = exports;
